import {getWorkbench} from "../getWorkbench";

export function getMainMenuEnvelope(ctx: any) {
  return getWorkbench(ctx).mainMenuEnvelope;
}